import { render, staticRenderFns } from "./DefaultBidSettings.vue?vue&type=template&id=7088d66d&scoped=true"
import script from "./DefaultBidSettings.vue?vue&type=script&lang=js"
export * from "./DefaultBidSettings.vue?vue&type=script&lang=js"
import style0 from "./DefaultBidSettings.vue?vue&type=style&index=0&id=7088d66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088d66d",
  null
  
)

export default component.exports